import { inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as actions from '../actions/content-pages.action';
import { switchMap, map, catchError } from 'rxjs/operators';
import { ContentPagesService } from '../../services';
import { Go } from 'src/app/store';

export const LoadPages$ = createEffect(
  (actions$ = inject(Actions), service = inject(ContentPagesService)) => {
    return actions$.pipe(
      ofType(actions.LoadContentPages),
      switchMap(() =>
        service.getPages().pipe(
          map(contentPages => actions.LoadContentPagesSuccess({ contentPages })),
          catchError(error => of(actions.LoadContentPagesFail({ error })))
        )
      )
    );
  },
  { functional: true }
);

export const LoadById$ = createEffect(
  (actions$ = inject(Actions), service = inject(ContentPagesService)) => {
    return actions$.pipe(
      ofType(actions.LoadContentPageById),
      switchMap(({ id }) =>
        service.getPageById(id).pipe(
          map(page => actions.LoadContentPageByIdSuccess({ page })),
          catchError(error => of(actions.LoadContentPageByIdFail({ id, error })))
        )
      )
    );
  },
  { functional: true }
);

export const LoadByIdFail$ = createEffect(
  (actions$ = inject(Actions)) => {
    return actions$.pipe(
      ofType(actions.LoadContentPageByIdFail),
      map(({ error }) => {
        return Go({ path: ['/' + error?.status ? error.status : '404'], extras: { skipLocationChange: true } });
      })
    );
  },
  { functional: true }
);
